<sh-card
  *ngIf="marker | async as marker"
  (click)="coilHistoryComponent.togglePhoneGrid()"
>
  <!-- eslint-disable-next-line -->
  <div
    class="coil-label-container card"
    (click)="toggleCoilExpansion(coil.coilSerialNumber); scrollToCoilName()"
    tabindex="0"
  >
    <!-- eslint-enable -->
    <span #coilName class="clickable-coil-label"> {{ coil.coilName }} </span>

    <sh-icon
      *ngIf="screenLayoutService.phone$ | async"
      class="flex"
      [icon]="changeArrowIcons()"
    ></sh-icon>
  </div>

  <div class="marker-icon-container">
    <sh-icon size="l" [icon]="marker.icon"></sh-icon>
    <div class="align-broken-cable">
      <sh-text size="header-2">
        {{ marker.status }}
      </sh-text>
      <img
        *ngIf="coil.isCableBroken"
        src="assets/icons/icon-broken-cable.svg"
        alt="Broken cable icon"
      />
    </div>
  </div>

  <ng-container
    *ngIf="
      currentlyExpandedCoil === coil.coilSerialNumber ||
      (screenLayoutService.phone$ | async) === false
    "
  >
    <div class="marker-toggle-div">
      <div class="broken-cable-aligment">
        <p
          class="marker-recommendation"
          [innerHTML]="
            coil.isCableBroken
              ? ('message.recommendation.brokenCable' | translate)
              : marker.recommendation
          "
        ></p>
      </div>

      <div>
        <sh-toggle
          *ngIf="(screenLayoutService.phone$ | async) === false"
          [label]="channelToggleLabel"
          (click)="coilHistoryComponent.toggleGrid()"
          role="button"
          aria-label="Toggle Channel History"
          (keyup)="coilHistoryComponent.handleEnterKey($event)"
        ></sh-toggle>
      </div>
    </div>

    <section>
      <app-coil-history [coil]="coil"></app-coil-history>

      <app-coil-information [coil]="coil"></app-coil-information>
    </section>
  </ng-container>
</sh-card>
